import { Outlet } from 'react-router'
import DataCollectionForm from '../components/DataCollectionForm/DataCollectionForm'
import { ReportsHome } from '../components/Reports/ReportsHome/ReportsHome'
import FarmData from '../components/FarmData/FarmData'
import HomePage from '../components/HomePage/HomePage'
import ManagementHome from '../components/ManagementHome/ManagementHome'
import MonitoringHome from '../components/Monitoring/MonitoringHome/MonitoringHome'
import { Report } from '../components/Reports/Report'

const MainRoutes = {
  path: '/',
  element: <Outlet />,
  children: [
    {
      path: '/',
      element: <HomePage />,
    },
    {
      path: '/farms',
      element: <FarmData />,
    },
    {
      path: '/management',
      element: <ManagementHome />,
    },
    {
      path: '/management/data/:year',
      element: <DataCollectionForm />,
    },
    {
      path: '/monitoring',
      element: <MonitoringHome />,
    },
    {
      path: '/reports',
      element: <ReportsHome />,
    },
    {
      path: '/reports/:reportType/:reportId',
      element: <Report />,
    },
  ],
}

export default MainRoutes
